var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsStaffmembersV1StaffMember from '@wix/ambassador-events-staffmembers-v1-staff-member/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Scope;
(function (Scope) {
    Scope["UNKNOWN_SCOPE"] = "UNKNOWN_SCOPE";
    /** Check in guests. */
    Scope["CHECK_IN_GUESTS"] = "CHECK_IN_GUESTS";
    /** Sell tickets. */
    Scope["SELL_TICKETS"] = "SELL_TICKETS";
})(Scope || (Scope = {}));
export var Status;
(function (Status) {
    /** Pending. Means that staff member has not joined. */
    Status["PENDING"] = "PENDING";
    /** Has access. */
    Status["HAS_ACCESS"] = "HAS_ACCESS";
    /** Access paused. When staff member is paused from performing actions. */
    Status["ACCESS_PAUSED"] = "ACCESS_PAUSED";
})(Status || (Status = {}));
export var Fieldset;
(function (Fieldset) {
    /** Includes join link. */
    Fieldset["JOIN_LINK"] = "JOIN_LINK";
})(Fieldset || (Fieldset = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _accessStaffMemberRequest = {};
const _accessStaffMemberResponse = {};
const _createStaffMemberRequest = {};
const _createStaffMemberResponse = {};
const _deleteStaffMemberRequest = {};
const _deleteStaffMemberResponse = {};
const _getStaffMemberRequest = {};
const _getStaffMemberResponse = {};
const _joinStaffMemberRequest = {};
const _joinStaffMemberResponse = {};
const _queryStaffMembersRequest = {};
const _queryStaffMembersResponse = {};
const _updateStaffMemberRequest = {};
const _updateStaffMemberResponse = {};
/**
 * Creates a staff member.
 * @param staffMember - Staff member to be created.
 * @public
 * @documentationMaturity preview
 * @requiredField staffMember
 * @adminMethod
 * @returns The created staff member.
 */
export function createStaffMember(staffMember) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { staffMember: '$[0]' };
        const responseTransformation = '$.staffMember';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createStaffMemberResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMember]);
        const reqOpts = ambassadorWixEventsStaffmembersV1StaffMember.createStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMember',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a staff member.
 * @param staffMemberId - ID of the staff member to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField staffMemberId
 * @adminMethod
 * @returns The requested staff member.
 */
export function getStaffMember(staffMemberId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            staffMemberId: '$[0]',
            fieldsets: '$[1].fieldsets',
        };
        const responseTransformation = '$.staffMember';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getStaffMemberResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMemberId, options]);
        const reqOpts = ambassadorWixEventsStaffmembersV1StaffMember.getStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMemberId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a staff member.
 *
 * Each time the staff member is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the staff member.
 * This ensures you're working with the latest staff member
 * and prevents unintended overwrites.
 * @param _id - Staff member ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField staffMember
 * @requiredField staffMember.revision
 * @adminMethod
 * @returns Updated staff member.
 */
export function updateStaffMember(_id, staffMember, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            staffMember: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
        };
        const responseTransformation = '$.staffMember';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateStaffMemberResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, staffMember, options]);
        const reqOpts = ambassadorWixEventsStaffmembersV1StaffMember.updateStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'staffMember',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a staff member.
 *
 * Deleting a staff member permanently removes them from the staff member List.
 * @param staffMemberId - Id of the staff member to delete.
 * @public
 * @documentationMaturity preview
 * @requiredField staffMemberId
 * @adminMethod
 */
export function deleteStaffMember(staffMemberId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { staffMemberId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteStaffMemberResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMemberId]);
        const reqOpts = ambassadorWixEventsStaffmembersV1StaffMember.deleteStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMemberId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of staff members, given the provided paging, filtering, and sorting.
 * @public
 * @documentationMaturity preview
 * @permissionId WIX_EVENTS.STAFF_MEMBER_READ
 * @adminMethod
 */
export function queryStaffMembers(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.staffMembers',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryStaffMembersRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryStaffMembersResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#staffMembers']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixEventsStaffmembersV1StaffMember.queryStaffMembers(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Joins as staff member if he's not in suspended status via provided token.
 * @param joinToken - Used to authorise staff member
 * @public
 * @documentationMaturity preview
 * @requiredField joinToken
 */
export function joinStaffMember(joinToken) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { joinToken: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _joinStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _joinStaffMemberResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([joinToken]);
        const reqOpts = ambassadorWixEventsStaffmembersV1StaffMember.joinStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'joinToken',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a staff by access token.
 * @param accessToken - Used to authorise staff member
 * @public
 * @documentationMaturity preview
 * @requiredField accessToken
 */
export function accessStaffMember(accessToken) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { accessToken: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _accessStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _accessStaffMemberResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accessToken]);
        const reqOpts = ambassadorWixEventsStaffmembersV1StaffMember.accessStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accessToken',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-staffmembers-v1-staff-member.universal.js.map